import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=868ccec6&scoped=true&"
import script from "./BankDetails.vue?vue&type=script&lang=js&"
export * from "./BankDetails.vue?vue&type=script&lang=js&"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=868ccec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "868ccec6",
  null
  
)

export default component.exports